import React from 'react';
import { InfoIcon, Text } from '@beef/ui-kit';
export var PriceError = function PriceError(_ref) {
  var className = _ref.className,
    errorPriceMessage = _ref.errorPriceMessage;
  return /*#__PURE__*/React.createElement("div", {
    className: className,
    "data-t-id": "components-PriceError"
  }, /*#__PURE__*/React.createElement(InfoIcon, {
    className: "mar-r-3xs",
    fill: "#ff916b",
    size: 18
  }), /*#__PURE__*/React.createElement(Text, {
    color: "grey60",
    size: "size5-r-s"
  }, errorPriceMessage));
};